import React, { Fragment } from 'react';
import { LinkPreview } from './LinkPreview';
export const Message = ({
  message
}) => {
  const isUser = message.type === 'user';
  // Function to parse content and extract links
  const renderContent = content => {
    // Simple regex to find URLs in text
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = content.split(urlRegex);
    return parts.map((part, index) => {
      if (part.match(urlRegex)) {
        return <LinkPreview key={index} url={part} data-id="element-174" />;
      }
      // Process text for line breaks
      return part.split('\n').map((line, i) => <Fragment key={i} data-id="element-175">
          {line}
          {i < part.split('\n').length - 1 && <br data-id="element-176" />}
        </Fragment>);
    });
  };
  return <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-2`} data-id="element-177">
      <div className={`max-w-[85%] sm:max-w-[80%] rounded-lg p-2 sm:p-3 text-sm ${isUser ? 'bg-blue-600 text-white rounded-tr-none shadow-sm' : 'bg-gray-100 text-gray-800 rounded-tl-none'}`} data-id="element-178">
        {renderContent(message.content)}
      </div>
    </div>;
};